import { Alignment } from "@novorender/api";
import { useEffect } from "react";

import { useAppDispatch, useAppSelector } from "app/redux-store-interactions";
import { useExplorerGlobals } from "contexts/explorerGlobals";
import { telemetry } from "telemetry";
import { AsyncStatus } from "types/misc";

import { selectAlignmentIds as selectAlignmentIds, selectAlignments } from "../selectors";
import { alignmentActions } from "../slice";

export function useGetAlignments() {
    const {
        state: { view },
    } = useExplorerGlobals();

    const alignmentIds = useAppSelector(selectAlignmentIds);
    const alignments = useAppSelector(selectAlignments);

    const dispatch = useAppDispatch();

    useEffect(() => {
        loadAlignments();

        async function loadAlignments() {
            if (alignments.status !== AsyncStatus.Initial || alignmentIds.status !== AsyncStatus.Success || !view) {
                return;
            }

            dispatch(alignmentActions.setAlignments({ status: AsyncStatus.Loading }));

            try {
                const newAlignments: { [key: string]: Alignment } = {};
                for (const alignmentId of alignmentIds.data) {
                    const alignment = await view.measure?.road.getAlignment(alignmentId.id);
                    if (alignment) {
                        newAlignments[alignmentId.name] = alignment;
                    }
                }
                dispatch(alignmentActions.setAlignments({ status: AsyncStatus.Success, data: newAlignments }));
            } catch (e) {
                telemetry.trackCaughtException({
                    source: "alignment.useGetAlignments.loadAlignments",
                    category: "data",
                    error: e,
                });
                dispatch(alignmentActions.setAlignments({ status: AsyncStatus.Error, msg: "An error occurred." }));
            }
        }
    }, [view, dispatch, alignments, alignmentIds]);

    return alignments;
}
